module.exports = __webpack_public_path__ + "static/images/monet/side_bar_title_background.png";